import ColumnChart from '../../../../../components/Charts/ColumnChart'
import { InfoContainer, SubTitle } from '../../styles'

export default function ReturnedMembers ({ data }) {
  if (!data || Object.keys (data).length === 0) {
    return null
  }

  const returnedMembers = [
    ['Mês', 'Membros que retornaram'],
    ...Object.entries (data).map (([month, values]) => [
      month, Number (values.returned) || 0
    ])
  ]

  return (
    <InfoContainer>
      <SubTitle>Membros que retornaram</SubTitle>
      <ColumnChart
        data={returnedMembers}
        legendPosition='top'
        options={{
          isStacked: false,
          height: 350,
          colors: ['#44CF6C'],
          legend: 'none',
          chartArea: { top: 20, left: 110, width: '75%', height: '75%' },
          vAxis: {
            title: 'Taxa (%)',
            minValue: 0,
            titleTextStyle: {
              bold: true
            }
          }
        }}
      />
    </InfoContainer>
  )
}
